import { useEffect, useState } from 'react';
import fr from 'facet-rest';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

export default function useActionItemSecureFiles(actionItemResource, {
  onDelete = () => {}, secureFilesApplicable = true,
}) {
  const [fileCollection, setFileCollection] = useState(null);

  const getFiles = async () => {
    try {
      if (secureFilesApplicable) {
        const coll = await actionItemResource.relationship(fr.relationships.getSecureFiles.name).link('related').get();
        setFileCollection(coll);
      } else {
        setFileCollection(null);
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  useEffect(() => {
    // Don't copy this pattern. The real fix is to conditionally return the relationship, in this case getSecureFiles, but this
    // client code was written assuming it would always exist, so conditionally returning it would cause unplugged errors on clients that
    // are on older versions.
    if (!actionItemResource || actionItemResource.id() === '0') {
      return;
    }
    getFiles();
  }, [actionItemResource]);

  const deleteFile = async (fileResource) => {
    try {
      await fileResource.delete();
      await getFiles();
      onDelete();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return {
    fileCollection,
    setFileCollection,
    deleteFile,
  };
}
